export enum DynamicFilterEnum {
  assortment = "assortment",
  division_product = "division_product",
  family = "family",
}
